namespace Areas.Vendor {
    "use strict";


   //BidRangeType
    export function onBidRangeTypeGridContentReady(e: any) {
        var vendorId = e.component.option("VendorId") as number;
        getVendorVendorBidRangeTypes(vendorId);
    }

    export function getVendorVendorBidRangeTypes(vendorId: number) {
        var checkGrid = $("#BidRangeTypeGrid").dxDataGrid("instance");

        $.ajax({
            url: `/Vendor/BidRange/GetVendorVendorBidRangeTypes/${vendorId}`,
            method: "GET",
            contentType: "application/json",
            success: (data) => {
                checkGrid.selectRows(data, false);
            },
            error: () => {
                DevExpress.ui.notify("Error getting bid range types for Vendor.", "error", 2000);
            }
        });
    }

    //BidOptionType
    export function onBidOptionTypeGridContentReady(e: any) {
        var vendorId = e.component.option("VendorId") as number;
        getVendorVendorBidOptionTypes(vendorId);
    }

    export function getVendorVendorBidOptionTypes(vendorId: number) {
        var checkGrid = $("#BidOptionTypeGrid").dxDataGrid("instance");

        $.ajax({
            url: `/Vendor/BidOption/GetVendorVendorBidOptionTypes/${vendorId}`,
            method: "GET",
            contentType: "application/json",
            success: (data) => {
                checkGrid.selectRows(data, false);
            },
            error: () => {
                DevExpress.ui.notify("Error getting bid range types for Vendor.", "error", 2000);
            }
        });
    }

    export function saveOptions() {
        const bidRangeGrid = $("#BidRangeTypeGrid").dxDataGrid("instance");
        const bidOptionGrid = $("#BidOptionTypeGrid").dxDataGrid("instance");
        var types = bidRangeGrid.getSelectedRowKeys();
        var options = bidOptionGrid.getSelectedRowKeys();
        var vendorId = bidRangeGrid.option("VendorId");
        var keyId = bidRangeGrid.option("VendorId");

        var data = JSON.stringify(
            {
                "VendorId" : vendorId,
                "RangeTypes": types,
                "OptionTypeIds": options
                });

            sendRequest(`/Vendor/BidRange/Put/${keyId}`, data, "PUT");
    }

    export function cancelFromTabs() {
        var linkInfo = "/Vendor/List/Index";
        location.href = linkInfo;

    }


    //Ownership
    export function onOwnershipGridContentReady(e: any) {
        var vendorId = e.component.option("VendorId") as number;
        getVendorVendorOwnershipTypes(vendorId);
    }

    export function getVendorVendorOwnershipTypes(vendorId: number) {
        var checkGrid = $("#OwnershipGrid").dxDataGrid("instance");

        $.ajax({
            url: `/Vendor/Ownership/GetVendorVendorOwnershipTypes/${vendorId}`,
            method: "GET",
            contentType: "application/json",
            success: (data) => {
                checkGrid.selectRows(data, false);
            },
            error: () => {
                DevExpress.ui.notify("Error getting ownership types for Vendor.", "error", 2000);
            }
        });
    }

    export function saveOwnershipRecord() {
        const ownershipGrid = $("#OwnershipGrid").dxDataGrid("instance");
       
        var types = ownershipGrid.getSelectedRowKeys();
        var vendorId = ownershipGrid.option("VendorId");
        var keyId = ownershipGrid.option("VendorId");

        var data = JSON.stringify(
            {
                "VendorId": vendorId,
                "NewOwnerTypes": types
            });

        sendRequest(`/Vendor/Ownership/Put/${keyId}`, data, "PUT");
    }


   
    //License
    export function onLicenseGridContentReady(e: any) {
        var vendorId = e.component.option("VendorId") as number;
        getVendorVendorLicenseTypes(vendorId);
    }

    export function getVendorVendorLicenseTypes(vendorId: number) {
        var checkGrid = $("#LicenseGrid").dxDataGrid("instance");

        $.ajax({
            url: `/Vendor/License/GetVendorVendorLicenseTypes/${vendorId}`,
            method: "GET",
            contentType: "application/json",
            success: (data) => {
                checkGrid.selectRows(data, false);
            },
            error: () => {
                DevExpress.ui.notify("Error getting license types for Vendor.", "error", 2000);
            }
        });
    }

    export function saveLicenseRecord() {
        const licenseGrid = $("#LicenseGrid").dxDataGrid("instance");

        var types = licenseGrid.getSelectedRowKeys();
        var vendorId = licenseGrid.option("VendorId");
        var keyId = licenseGrid.option("KeyId")

        var data = JSON.stringify(
            {
                "VendorId": vendorId,
                "NewLicenseTypes": types
            });

        sendRequest(`/Vendor/License/Put/${keyId}`, data, "PUT");
    }


    //Specialty
    export function onSpecialtyGridContentReady(e: any) {
        var vendorId = e.component.option("VendorId") as number;
        getVendorVendorSpecialtyCodes(vendorId);
    }

    export function getVendorVendorSpecialtyCodes(vendorId: number) {
        var checkGrid = $("#SpecialtyGrid").dxDataGrid("instance");

        $.ajax({
            url: `/Vendor/Specialty/GetVendorVendorSpecialtyCodes/${vendorId}`,
            method: "GET",
            contentType: "application/json",
            success: (data) => {
                checkGrid.selectRows(data, false);
            },
            error: () => {
                DevExpress.ui.notify("Error getting specialty codes for Vendor.", "error", 2000);
            }
        });
    }

    export function saveSpecialty() {
        const specialtyGrid = $("#SpecialtyGrid").dxDataGrid("instance");

        var types = specialtyGrid.getSelectedRowKeys();
        var vendorId = specialtyGrid.option("VendorId");
        var keyId = specialtyGrid.option("KeyId")

        var data = JSON.stringify(
            {
                "VendorId": vendorId,
                "NewSpecialtyCodes": types
            });

        sendRequest(`/Vendor/Specialty/Put/${keyId}`, data, "PUT");
    }


}